import { createStore } from "vuex";
import { supabase } from "@/supabase";
import ProjectService from "@/services/Project";
import { Project, ImageInfo, Line } from "@/helpers/Interfaces";

export default createStore({
  state: {
    user: null as any,
    isAdmin: false,
    isApproved: false,
    currentProject: null as Project | null,
    images: [] as ImageInfo[],
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
    },
    setPermissions(state, { isAdmin, isApproved }) {
      state.isAdmin = isAdmin;
      state.isApproved = isApproved;
    },
    setCurrentProject(state, project: Project) {
      state.currentProject = project;
    },
    setImages(state, images: ImageInfo[]) {
      state.images = images;
    },
    updateImageLines(state, { imageId, lines }: { imageId: number; lines: Line[] }) {
      const imageIndex = state.images.findIndex(img => img.id === imageId);
      if (imageIndex !== -1) {
        state.images[imageIndex].has_lines = lines.length > 0;
      }
    }
  },
  actions: {
    async fetchUser({ commit }) {
      //const { data: { user } } = await supabase.auth.getUser();
      const { data: { session } } = await supabase.auth.getSession();
      const user = session?.user ?? null;      
      commit("setUser", user);

      if (user) {
        const { data: profile, error } = await supabase
          .from("profiles")
          .select("isadmin, isapproved")
          .eq("user_id", user.id)
          .maybeSingle();

        if (!error && profile) {
          commit("setPermissions", { isAdmin: profile.isadmin, isApproved: profile.isapproved });
        }
      }
    },

    async fetchProject({ commit }, projectId: number) {
      try {
          const project = await ProjectService.getProjectById(projectId);
          if (project) {
              commit("setCurrentProject", project);
          } else {
              console.warn(`Projeto com ID ${projectId} não encontrado.`);
              commit("setCurrentProject", null);
          }
      } catch (err) {
          console.error("Erro ao buscar projeto:", err);
          commit("setCurrentProject", null);
      }
    },

    async fetchImages({ commit, state }) {
      if (!state.currentProject || state.currentProject.id === undefined) {
          console.error("Erro: currentProject ou o seu ID não está definido!");
          return;
      }
  
      const images = await ProjectService.getImagesFromProject(state.currentProject.id);
      commit("setImages", images);
    }
  }
});
